export const INVOICE_STATUS_ID = {
  NO_PAGADA: 1,
  PAGADA: 2,
}

export const isInvoicePaid = ({ statusId, statusName } = {}) => {
  if (statusId != null) {
    return Number(statusId) === INVOICE_STATUS_ID.PAGADA
  }
  return String(statusName || '').toLowerCase().includes('pagada')
}

export const mapInvoiceFromApi = (invoice) => ({
  id: invoice.id,
  invoiceNumber: invoice.title,
  created_at: invoice.created_at || invoice.issue_date,
  due_date: invoice.due_date,
  description: invoice.description || invoice.descriptrion || '',
  total_amount: Number(invoice.total_amount || 0),
  currencyCode: invoice.coin?.short_name || 'EUR',
  companyName: invoice.company?.name || '',
  statusName: invoice.invoice_status?.name || '—',
  statusId: invoice.invoice_status?.id ?? null,
  accept: Boolean(invoice.accept),
})

export const getInvoiceStatusBadgeStyle = (invoice) => {
  const paid = isInvoicePaid(invoice)
  return {
    background: paid ? '#dcfce7' : '#fef2f2',
    color: paid ? '#166534' : '#991b1b',
  }
}
